import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  DeliveryBatchAction,
  DeliveryBatchItem,
  DeliveryBatchPayment,
  DeliveryBatchResult,
  DeliveryClientPayload,
  DeliveryQrSource,
} from "@mnp/shared";
import { api } from "./api.js";

export function useDeliveryByQr(qr: string, source: DeliveryQrSource = "scan") {
  const cleanQr = qr.trim();
  return useQuery<DeliveryClientPayload>({
    queryKey: ["delivery-by-qr", cleanQr, source],
    queryFn: () =>
      api<DeliveryClientPayload>(
        `/admin/delivery/by-qr?qr=${encodeURIComponent(cleanQr)}&source=${source}`,
      ),
    enabled: cleanQr.length > 0,
    retry: false,
  });
}

export interface DeliveryBatchInput {
  items: DeliveryBatchItem[];
  action: DeliveryBatchAction;
  payment?: DeliveryBatchPayment;
  reason?: string;
}

export function useDeliveryBatch() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: DeliveryBatchInput) =>
      api<DeliveryBatchResult>("/admin/delivery/batch", {
        method: "POST",
        body: JSON.stringify(payload),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["delivery-by-qr"] });
    },
  });
}
